module.exports = __webpack_public_path__ + "images/smile389623c78bf435d599b9474a221e4429.png";